import "./modal.css";
import close from "../../assets/svgs/close.svg";
import { ButtonGeneric } from "../ButtonGeneric/buttonGeneric";

interface ModalProps {
  titleModal?: string;
  titleDescription?: string;
  bodyModal?: any;
  buttonOne?: string;
  buttonTwo?: string;
  onClose?: () => void;
  onConfirm?: () => void;
  className?: string;
  closes?: string;
  disabled?: boolean;
}

export const Modal = ({
  titleModal,
  titleDescription,
  bodyModal,
  buttonOne,
  buttonTwo,
  onClose,
  onConfirm,
  className,
  closes,
  disabled,
}: ModalProps) => {
  return (
    <div className={`modalCorporate ${className}`}>
      <div className="modal">
        <div>
          <div className="containerTitleModal">
            {titleModal && <h1 className="titleModal">{titleModal}</h1>}
            {closes && (
              <button
                type="button"
                onClick={onClose}
                className="closeButton"
                aria-label="Fechar modal"
              >
                <img
                  src={close}
                  alt="icon close"
                  width={15}
                  height={15}
                />
              </button>
            )}
          </div>
          <div className="line"></div>
          <div className="containerDescription">
            {titleDescription && (
              <span className="titleDescription">{titleDescription}</span>
            )}

            {bodyModal && (
              <span className="bodyModal" id="bodyModalStyle">
                {bodyModal}
              </span>
            )}

            <div className="buttonsEdit ">
              {buttonOne && (
                <ButtonGeneric
                  style="buttonGenericCustom buttonGeneric buttonHover"
                  title={buttonOne}
                  colorTitle="#fff"
                  onClick={onClose}
                  disabled={disabled}
                />
              )}
              {buttonTwo && (
                <ButtonGeneric
                  style="buttonGenericCustom"
                  title={buttonTwo}
                  colorTitle="#007BC0"
                  onClick={onConfirm}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
